module.exports = __webpack_public_path__ + "img/section04-img01.ce65197f.png";